import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { formatIQD } from '../../../shared/format.js';

function normalize(data) {
  const arr = Array.isArray(data) ? data : data?.data || data?.items || [];
  return arr.map((r, i) => ({
    name: r.cashierName ?? r.name ?? r.fullName ?? `كاشير ${i + 1}`,
    revenue: Number(r.salesTotal ?? r.revenue ?? r.total ?? r.amount ?? 0),
    invoices: Number(r.invoicesCount ?? r.invoices ?? r.count ?? 0)
  }));
}

function formatYAxis(v) {
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}م`;
  if (v >= 1_000) return `${Math.round(v / 1_000)}ك`;
  return v;
}

export function CashierBars({ data, height = 260 }) {
  const rows = normalize(data);
  if (!rows.length) {
    return <div className="h-[220px] grid place-items-center text-ink-3 text-xs">لا توجد بيانات بعد</div>;
  }
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={rows} layout="vertical" margin={{ top: 10, right: 16, left: 16, bottom: 4 }}>
          <CartesianGrid stroke="#F0E6DA" horizontal={false} />
          <XAxis type="number" tickFormatter={formatYAxis} tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
          <YAxis
            dataKey="name"
            type="category"
            tick={{ fontSize: 11.5, fill: '#374151' }}
            axisLine={false}
            tickLine={false}
            width={120}
          />
          <Tooltip
            cursor={{ fill: 'rgba(255,122,26,.06)' }}
            formatter={(v, key) => (key === 'invoices' ? `${v} فاتورة` : formatIQD(v))}
            contentStyle={{ background: '#fff', border: '1px solid #EFE7D6', borderRadius: 10, fontSize: 12 }}
          />
          <Bar dataKey="revenue" name="المبيعات" fill="#FF7A1A" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
